<template>
  <v-card>
    <v-card-text>
      <v-list dense subheader>
        <v-subheader>{{ $t('editFicheLayout') }}</v-subheader>
        <v-btn small @click="reset()" flat v-if="true">
          <v-icon left>settings_backup_restore</v-icon>
          {{ $t('cancel') }}
        </v-btn>
        <draggable v-model="items" @change="writecookie()" :options="options">
          <transition-group name="slide-x-transition">
            <v-list-tile
              v-for="(item, i) in items"
              :key="item.title"
            >
                <v-list-tile-action>
                  <v-checkbox v-model="item.show" slot="activator" @change="writecookie()"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ $tc(item.title, 2, {count: ''}) | cap }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="false">
                  <v-layout row>
                    <v-flex class="mr-2">
                      <v-btn small icon @click="down(i)">
                        <v-icon color="red">arrow_downward</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex class="mr-2">
                      <v-btn small icon @click="up(i)">
                        <v-icon color="green">arrow_upward</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex>
                      <v-btn small icon class="drag-handle">
                        <v-icon>drag_indicator</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-list-tile-action>
              </v-list-tile>
          </transition-group>
        </draggable>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { FORM_LAYOUT } from '../../constants.js'
import _ from 'lodash'
import draggable from 'vuedraggable'
import '../../assets/css/dragndrop.css'
export default {
  components: {
    draggable
  },
  data () {
    return {
      items: null,
      options: {
        handle: '.drag-handle',
        ghostClass: 'drag-ghost',
        animation: 100
      }
    }
  },

  mounted () {
    let itemsFromCookie = JSON.parse(this.$cookie.get('wz-fiche-visiteur'))
    this.items = itemsFromCookie || _.cloneDeep(FORM_LAYOUT)
  },

  methods: {
    up (index) {
      if (index === 0) {
        return
      }
      let newIndex = index--
      this.swap(index, newIndex)
    },
    down (index) {
      if (index === this.items.length - 1) {
        return
      }
      let newIndex = index++
      this.swap(index, newIndex)
    },
    swap (src, dest) {
      let itemTmp = _.cloneDeep(this.items[dest])
      this.items.splice(dest, 1, this.items[src])
      this.items.splice(src, 1, itemTmp)
      this.writecookie()
    },
    reset () {
      this.$cookie.delete('wz-fiche-visiteur')
      this.items = _.cloneDeep(FORM_LAYOUT)
      this.writecookie()
    },
    writecookie () {
      this.$cookie.set('wz-fiche-visiteur', JSON.stringify(this.items), {
        expires: '1Y'
      })
      this.$emit('update')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzChooseLayoutFicheVisiteur.vue